import React from 'react';
import SharedHelmet from '../.././Helmet';
const TITLE = 'قائمة النسب المئوية لأي رقم من 1 إلى 100';
const DESCRIPTION = 'استخدم هذه الأداة لحساب النسبة المئوية لأي رقم بين 1 و 100 بسهولة ودقة. توفر لك هذه الآلة الحاسبة طريقة سريعة وفعالة لإيجاد النسبة المئوية لأرقام معينة.';
const KEYWORDS = 'حاسبة النسبة المئوية, حساب النسبة المئوية, أداة النسبة المئوية, النسبة المئوية, حساب الأرقام, أرقام من 1 إلى 100';
const OG_URL = 'https://do-calculate.com/calculator/ar/percentage_converter/percentage_list';
const numberToArabic = {
    1: 'واحد',
    2: 'اثنان',
    3: 'ثلاثة',
    4: 'أربعة',
    6: 'ستة',
    7: 'سبعة',
    8: 'ثمانية',
    9: 'تسعة',
    11: 'أحد عشر',
    12: 'اثنا عشر',
    13: 'ثلاثة عشر',
    14: 'أربعة عشر',
    16: 'ستة عشر',
    17: 'سبعة عشر',
    18: 'ثمانية عشر',
    19: 'تسعة عشر',
    21: 'واحد وعشرون',
    22: 'اثنان وعشرون',
    23: 'ثلاثة وعشرون',
    24: 'أربعة وعشرون',
    26: 'ستة وعشرون',
    27: 'سبعة وعشرون',
    28: 'ثمانية وعشرون',
    29: 'تسعة وعشرون',
    31: 'واحد وثلاثون',
    32: 'اثنان وثلاثون',
    33: 'ثلاثة وثلاثون',
    34: 'أربعة وثلاثون',
    36: 'ستة وثلاثون',
    37: 'سبعة وثلاثون',
    38: 'ثمانية وثلاثون',
    39: 'تسعة وثلاثون',
    41: 'واحد وأربعون',
    42: 'اثنان وأربعون',
    43: 'ثلاثة وأربعون',
    44: 'أربعة وأربعون',
    45: 'خمسة وأربعون',
    46: 'ستة وأربعون',
    47: 'سبعة وأربعون',
    48: 'ثمانية وأربعون',
    49: 'تسعة وأربعون',
    50: 'خمسون',
    51: 'واحد وخمسون',
    52: 'اثنان وخمسون',
    53: 'ثلاثة وخمسون',
    54: 'أربعة وخمسون',
    55: 'خمسة وخمسون',
    56: 'ستة وخمسون',
    57: 'سبعة وخمسون',
    58: 'ثمانية وخمسون',
    59: 'تسعة وخمسون',
    60: 'ستون',
    61: 'واحد وستون',
    62: 'اثنان وستون',
    63: 'ثلاثة وستون',
    64: 'أربعة وستون',
    65: 'خمسة وستون',
    66: 'ستة وستون',
    67: 'سبعة وستون',
    68: 'ثمانية وستون',
    69: 'تسعة وستون',
    70: 'سبعون',
    71: 'واحد وسبعون',
    72: 'اثنان وسبعون',
    73: 'ثلاثة وسبعون',
    74: 'أربعة وسبعون',
    76: 'ستة وسبعون',
    77: 'سبعة وسبعون',
    78: 'ثمانية وسبعون',
    79: 'تسعة وسبعون',
    80: 'ثمانون',
    81: 'واحد وثمانون',
    82: 'اثنان وثمانون',
    83: 'ثلاثة وثمانون',
    84: 'أربعة وثمانون',
    85: 'خمسة وثمانون',
    86: 'ستة وثمانون',
    87: 'سبعة وثمانون',
    88: 'ثمانية وثمانون',
    89: 'تسعة وثمانون',
    90: 'تسعون',
    91: 'واحد وتسعون',
    92: 'اثنان وتسعون',
    93: 'ثلاثة وتسعون',
    94: 'أربعة وتسعون',
    95: 'خمسة وتسعون',
    96: 'ستة وتسعون',
    97: 'سبعة وتسعون',
    98: 'ثمانية وتسعون',
    99: 'تسعة وتسعون',
    100: 'مئة'
};
const PercentageList = () => {
    const numbers = Object.keys(numberToArabic).map(Number);
    return (
        <div>
            <div className="container rtl-container">
                <SharedHelmet TITLE={TITLE} DESCRIPTION={DESCRIPTION} KEYWORDS={KEYWORDS} OG_URL={OG_URL}  />
                <div>
                    <h1 style={{ fontSize: '26px' }}>{TITLE}</h1>
                    <hr />
                    <div className="alert alert-secondary" role="alert">
                        <p>{DESCRIPTION}</p>
                    </div>
                </div>
                <hr />
                <table >
                    <thead>
                        <tr>
                            <th >النسبة المئوية</th>
                            <th >الذهاب الى الحاسبة</th>
                        </tr>
                    </thead>
                    <tbody>
                        {numbers.map((number) => {
                            const percentage = number;
                            const arabicWord = numberToArabic[number];
                            return (
                                <tr key={number}>
                                    <td>{percentage}% - {arabicWord}</td>
                                    <td>
                                        <a href={`/calculator/ar/percentage_converter/${percentage}/`}>
                                            انتقل إلى حاسبة {percentage} %
                                        </a>
                                    </td>
                                </tr>
                            );
                        })}
                    </tbody>
                </table>
                <br />
            </div>
        </div>
    );
};
export default PercentageList;
